import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatDialogModule } from '@angular/material/dialog';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { ChallengeInlineDialogComponent } from './components/challenge-inline-dialog/challenge-inline-dialog.component';
import { QrRejectDialogComponent } from './components/qr-reject-dialog/qr-reject-dialog.component';

@NgModule({
  declarations: [ChallengeInlineDialogComponent, QrRejectDialogComponent],
  imports: [
    CommonModule,
    MatDialogModule,
    MatProgressSpinnerModule,  
  ],
  exports: [ChallengeInlineDialogComponent, QrRejectDialogComponent]
})
export class ChallengeInlineDialogModule {}
